module.exports = __webpack_public_path__ + "c4ad76855ba128c5042205e28c8944b0.jpg";